export default __webpack_public_path__ + "static/media/gesture_flow_banner.c4d82be5.png";